import React from 'react'

import View from './View.jsx'

const Container = ({ condoData }) => {
  return <View title="Lista Clientes" condoData={condoData} />
}

export default Container
